import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, OutlinedInput, Typography, Link } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalStateContext } from '../../context/GlobalStateContext/GlobalStateContext';
import { useOnboardingContext } from '../../context/OnboardingContext/OnboardingContext';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import { stripNumbersAndSpecialChars } from '../../utils/string.helpers';
import { ActionButton } from '../Button/Button';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import styles from './styles';
export const OnboardingPreferredName = () => {
    const { t: text } = useTranslation();
    const [preferredName, setPreferredName] = React.useState('');
    const { processOnboarding, onboardingContextState } = useOnboardingContext();
    const { globalState: { merchant }, fetchUser, } = useGlobalStateContext();
    const [error, setError] = React.useState('');
    const { updateStep } = useOnboardingContext();
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    const isLargeDesktop = !isTablet && isDesktop;
    const handleOnChange = (e) => {
        setError('');
        // setInSubmit(false);
        const inputValue = e.target.value;
        let nameStr = stripNumbersAndSpecialChars(inputValue);
        if (nameStr.length > 25) {
            nameStr = nameStr.slice(0, 25);
        }
        setPreferredName(nameStr);
    };
    useEffect(() => {
        const fetchPreferredName = async () => {
            await fetchUser();
        };
        fetchPreferredName().catch((e) => console.log(e));
    }, []);
    useEffect(() => {
        setPreferredName(merchant?.preferredName || '');
    }, [merchant]);
    const handleSubmit = async () => {
        if (!preferredName || error) {
            setError(text('ONBOARDING_CHANGE_NAME_INPUT_ERROR'));
            return false;
        }
        try {
            await processOnboarding({
                preferredName,
            }, 6);
            localStorage.setItem('idi-merchant-no', merchant?.number?.toString() || '');
        }
        catch (e) {
            console.log('Preferred name setup error', e);
        }
    };
    const handleSkip = async () => {
        try {
            await processOnboarding({}, //skip preferred name just to toggle Onboarding flag
            6);
            localStorage.setItem('idi-merchant-no', merchant?.number?.toString() || '');
        }
        catch (e) {
            console.log('Preferred name setup error', e);
        }
    };
    return (_jsxs(Box, { sx: styles.pageContentWrapper(isLargeDesktop), children: [onboardingContextState?.apiReply?.success === undefined && (_jsx(Box, { children: _jsx(ErrorMessage, { message: text('ERROR_ON_PAGE') }) })), isDesktop && (_jsxs(Box, { sx: { flex: '0', width: '100%!important' }, children: [_jsx(Typography, { variant: 'h1', sx: { mt: '1rem' }, children: text('ONBOARDING_CHANGE_NAME_TITLE') }), _jsx(Box, { sx: styles.subtitle, children: _jsx(Typography, { variant: 'subtitle2', sx: { margin: '1rem 0 0' }, children: text('ONBOARDING_CHANGE_NAME_SUBTITLE') }) })] })), _jsx(Box, { mb: 2, children: _jsx(Typography, { mb: 1, mt: 4, variant: 'h2', children: text('ONBOARDING_CHANGE_NAME_TITLE2') }) }), _jsxs(Box, { mb: 8, children: [_jsx("label", { htmlFor: 'preferredName', children: _jsx(Typography, { mb: 1, variant: 'body2', children: text('ONBOARDING_CHANGE_NAME_INPUT_LABEL') }) }), _jsx(OutlinedInput, { value: preferredName, error: false, fullWidth: true, sx: { background: 'white' }, onChange: handleOnChange, name: 'preferredName', id: 'preferredName' }), _jsx(Box, { children: error && _jsx(ErrorMessage, { type: 'Plain', message: error }) }), _jsx(Typography, { mb: 1, variant: 'body2', sx: { fontSize: '0.75rem' }, mt: 1, children: text('ONBOARDING_CHANGE_NAME_INPUT_DESCRIPTION') }), !isDesktop && (_jsx(Box, { mt: 6, sx: { textAlign: 'center' }, children: _jsx(Link, { target: '_blank', variant: 'subtitle2', sx: { fontSize: '0.875rem', textDecoration: 'none', cursor: 'pointer' }, onClick: () => {
                                handleSkip();
                            }, tabIndex: 0, onKeyDown: (e) => {
                                if (e.key === 'Enter') {
                                    handleSkip();
                                }
                            }, children: text('ONBOARDING_CHANGE_NAME_SKIP_STEP') }) }))] }), _jsxs(Box, { sx: styles.ctaButtonsWrapper, children: [_jsx(ActionButton, { type: 'secondary', text: text('SET_UP_SMS_GO_BACK'), onClick: () => {
                            updateStep(2);
                        } }), _jsx(ActionButton, { type: 'primary', text: text('CONTINUE'), onClick: () => {
                            handleSubmit();
                        } })] }), isDesktop && (_jsx(Box, { mt: 4, sx: { textAlign: 'center', width: '371px!important' }, children: _jsx(Link, { target: '_blank', variant: 'subtitle2', onClick: () => {
                        handleSkip();
                    }, sx: { textDecoration: 'none', cursor: 'pointer' }, tabIndex: 0, onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            handleSkip();
                        }
                    }, children: text('ONBOARDING_CHANGE_NAME_SKIP_STEP') }) }))] }));
};
